module KendoExtension {
    var oldSearchValueList = {};
    var filterDelay: number = 1000;

    export class Grid extends kendo.ui.Grid {
        public static extraFilterData: string = null;

        static setupQuickSearch() {
            var $grids = $(".a-quickSearchGrid");
            KendoExtension.Grid.setupQuickSearchFilters($grids, false);
            $grids = $(".a-quickSearchPersistedGrid");
            KendoExtension.Grid.setupQuickSearchFilters($grids, true);
        }

        static onEdit(e: kendo.ui.GridEditEvent) {
            KendoExtension.Editor.setup(e.container);
            KendoExtension.Grid.setupTooltips(e.container);
            KendoExtension.Editor.checkReadonly(e);
        }

        static onRequestEndWithGridResize(e: kendo.data.DataSourceRequestEndEvent) {
            KendoExtension.Grid.onRequestEnd(e);
            if (e.type == "read" && !e.response.Errors) {
                var grids = $(".k-grid");
                for (var i = 0; i < grids.length; i++) {
                    var grid = <kendo.ui.Grid>$(grids[i]).data("kendoGrid");
                    if (grid.dataSource === e.sender) {
                        KendoExtension.Grid.adjustSize(grid);
                        break;
                    }
                }
            }
        }

        static onRequestEnd(e: kendo.data.DataSourceRequestEndEvent) {

            // toastr.options = { "positionClass": "toast-top-full-width" };
            if (e.type == "update" && !e.response.Errors) {
                toastr.success("Save Successful");
                e.sender.read();
            }

            if (e.type == "create" && !e.response.Errors) {
                toastr.success("New Record Added Successfully");
                e.sender.read();
            }

            if (e.type == "destroy" && !e.response.Errors) {
                toastr.success("Record Deleted Successfully");
                e.sender.read();
            }
        }

        static onError(e: kendo.data.DataSourceErrorEvent) {
            var errorMessage = "";
            for (var lError in e.errors) {
                errorMessage = e.errors[lError].errors[0].toString();
            }
            // check for errors related to invalid characters.
            if (e.errorThrown && errorMessage == "") {
                if (e.xhr != null && e.xhr.responseText.toLocaleLowerCase().search("<title>") != -1) {
                    var startPosition = e.xhr.responseText.toLocaleLowerCase().indexOf("<title>") + 7;
                    var endPosition = e.xhr.responseText.toLocaleLowerCase().indexOf("</title>");
                    errorMessage = e.xhr.responseText.substr(startPosition, endPosition - startPosition);
                } else {
                    errorMessage = "Unknown Grid Error";
                }
            }

            toastr.error(errorMessage);
            if (errorMessage.toLocaleLowerCase().search("Delete") != -1)
                e.sender.cancelChanges();
            else {
                var grids = $(".k-grid");
                for (var i = 0; i < grids.length; i++) {
                    var grid = <kendo.ui.Grid>$(grids[i]).data("kendoGrid");
                    if (grid.dataSource === e.sender) {
                        grid.one("dataBinding", event => {
                            event.preventDefault(); // cancel grid rebind
                        });
                        break;
                    }
                }
            }
        }

        static onCancel(e) {
            var grids = $(".k-grid");
            for (var i = 0; i < grids.length; i++) {
                var grid = <kendo.ui.Grid>$(grids[i]).data("kendoGrid");
                if (grid.dataSource === e.sender.dataSource) {
                    grid.cancelRow();
                    KendoExtension.Grid.makeRowButtonsImageOnly(grid.element);
                    break;
                }
            }
            e.preventDefault();
            e.sender.refresh();
        }

        static onDataBound(e) {
            var grid = e.sender;
            KendoExtension.Grid.makeRowButtonsImageOnly(grid.element);

            // Get request object
            var requestObject = (new kendo.data.transports["aspnetmvc-server"]({ prefix: "" }))
                .options.parameterMap({
                    page: grid.dataSource.page(),
                    sort: grid.dataSource.sort(),
                    filter: grid.dataSource.filter()
                });

            // Get the export link as jQuery object
            var $exportLink = grid.wrapper.find('.grid-export');
            $exportLink.text('');
            if ($exportLink != undefined) {
                // Get its 'href' attribute - the URL where it would navigate to
                var href = $exportLink.attr('href');

                if (href != undefined) {
                    // Update the 'page' parameter with the grid's current page
                    href = href.replace(/page=([^&]*)/, 'page=1' || '~');

                    // Update the 'sort' parameter with the grid's current sort descriptor
                    href = href.replace(/sort=([^&]*)/, 'sort=' + requestObject.sort || '~');

                    // Update the 'pageSize' parameter with the grid's current pageSize
                    href = href.replace(/pageSize=([^&]*)/, 'pageSize=' + grid.dataSource.total());

                    //update filter descriptor with the filters applied
                    href = href.replace(/filter=([^&]*)/, 'filter=' + requestObject.filter || '~');

                    //Set Custom Parameters
                    var searchString = "sort=" + requestObject.sort;
                    var fpos = href.indexOf(searchString);
                    fpos += searchString.length + 1;
                    var spos = href.indexOf("=", fpos);
                    var loopCounter = 0;
                    while (spos > 1 && loopCounter < 10) {
                        var fieldName = href.substr(fpos, spos - fpos);
                        var fValue;
                        try {
                            fValue = $("#" + fieldName).val();
                        } catch (ex) {
                            fValue = undefined;
                        }
                        if (fValue != undefined) {
                            var regExp = new RegExp(fieldName + "=([^&]*)");
                            href = href.replace(regExp, fieldName + '=' + fValue || '~');
                            searchString = fieldName + '=' + fValue;
                            fpos = href.indexOf(searchString, fpos);
                            fpos += searchString.length + 1;
                        } else {
                            fpos = spos + 1;
                        }
                        spos = href.indexOf("=", fpos);
                        loopCounter += 1;
                    }

                    //Get Title and Field Name for each column.
                    var gridColumns = "";
                    for (var i = 0; i < grid.columns.length; i++) {
                        var title = grid.columns[i].title,
                            field = grid.columns[i].field;
                        if (grid.columns[i].hidden || typeof (field) === "undefined") {
                            continue; /* no data! */
                        }
                        if (typeof (title) === "undefined") {
                            title = field;
                        }
                        gridColumns += encodeURIComponent(title) + ":" + field;
                        gridColumns += ",";
                    }
                    gridColumns = gridColumns.substr(0, gridColumns.length - 1);

                    var nRef = href.substr(0, href.indexOf('columnNames'));
                    nRef = nRef + 'columnNames=' + encodeURIComponent(gridColumns);
                    href = nRef;

                    // Update the 'href' attribute
                    $exportLink.attr('href', href);
                }
            }

        }

        static adjustGridSize(gridName: string = null) {
            var grid;
            if (gridName === null) { //There should be only one grid.
                grid = <kendo.ui.Grid>$(".k-grid").data("kendoGrid");
            } else {
                grid = <kendo.ui.Grid>$("#" + gridName).data("kendoGrid");
            }
            if (grid != undefined)
                KendoExtension.Grid.adjustSize(grid);
        }

        static adjustSize(grid: kendo.ui.Grid) {
            if (grid == null)
                return;
            //Get reference to grid container and data area.
            var gridElement = grid.element;
            var dataArea = gridElement.find(".k-grid-content");

            //Get height of Tool-bar, Header and footer  
            var otherElements = gridElement.children().not(".k-grid-content, .k-grid-container");
            var otherElementsHeight = 0;
            otherElements.each(function () {
                otherElementsHeight += $(this).outerHeight();
            });

            //Get height of window minus page footer
            var gridpos = 0;
            if (gridElement.offset() != undefined)
                gridpos = gridElement.offset().top;
            var newGridHeight = $(window).height() - gridpos - 5;

            //Calculate data area height
            var newDataAreaHeight = newGridHeight - otherElementsHeight;

            //Set the height for the grid container and data area

            gridElement.height(newGridHeight);
            dataArea.height(newDataAreaHeight);
        }

        static initializeSearchBox(grid: kendo.ui.Grid, persistFilter: boolean = true, searchTextbox: any = null, milliSecondsToDelay: number = 2000) {
            if (!grid) {
                return;
            }
            persistFilter = persistFilter || false;
            var searchBoxId = "quickSearch_" + grid.element[0].id;
            if (persistFilter) {
                searchBoxId = "persisted_" + searchBoxId;
            }
            if (!searchTextbox) {

                searchTextbox = $(' <span class="k-searchbox k-input k-input-md k-rounded-md k-input-solid k-grid-search"><span class="k-icon k-font-icon k-i-search k-input-icon"></span><input autocomplete="off" class="k-input-inner k-quicksearch-textbox" title="Search" placeholder="Search..." type="text" data-role="tooltip" id="' + searchBoxId + '"></span>');
                var $searchDiv = $('<div class="a-quick-search-container">');
                $searchDiv.append(searchTextbox);

                var $toolbarDiv = grid.element.find('.k-toolbar.k-grid-toolbar');
                $toolbarDiv.append($searchDiv);
                $('.a-quick-search-container').before('<span class="k-spacer"></span>')

            } else {
                oldSearchValueList[searchBoxId] = searchTextbox.val(); //set the initial search value.
            }
            searchTextbox.keyup(e => {
                if (e.keyCode == 27) {
                    searchTextbox.val("");
                }
            });
            if (persistFilter) {
                searchTextbox.val(Cookies.get(searchBoxId));
            }
            filterDelay = milliSecondsToDelay || 2000;

            grid.bind("dataBound", () => {
                setTimeout(() => { KendoExtension.Grid.checkSearchChanged(grid, searchTextbox); }, filterDelay);
            });
            setTimeout(() => { KendoExtension.Grid.checkSearchChanged(grid, searchTextbox); }, filterDelay);
        }

        static setupTooltips($container: JQuery) {
            $container.find("[title]").each(
                function (index, element) {
                    var $element = $(element);
                    var helpText = $element.prop("title");
                    var $parent = $element.parent();
                    $element.removeAttr("title");
                    if (helpText) {
                        if ($parent.hasClass("k-dropdown") || $parent.hasClass("k-numeric-wrap")) {
                            $parent.kendoTooltip({ content: helpText });
                        } else {
                            var isSpinner = false;
                            if ($element.hasClass("k-icon") && ($element.hasClass("k-i-arrow-n") || $element.hasClass("k-i-arrow-s"))) {
                                var $parents = $element.parents();
                                if ($parents.find(".k-widget .k-numerictextbox")) {
                                    isSpinner = true;
                                }
                            }
                            if (!isSpinner) {
                                $element.kendoTooltip({ content: helpText });
                            }
                        }
                    }
                }
            );
        }

        // Checks regularly if the search box has changed
        // Requests a Grid update on any change
        private static checkSearchChanged(grid: kendo.ui.Grid, searchTextbox: any) {
            var searchBoxId = searchTextbox.id;
            if (searchBoxId == null) {
                searchBoxId = searchTextbox[0].id;
            }
            var currentSearchValue = searchTextbox.val();
            var oldSearchValue = oldSearchValueList[searchBoxId];
            if (oldSearchValue == null) {
                oldSearchValue = "";
            }
            if (grid == null) { //null if grid is removed from page
                return; //prevent re-setting the setTimeout
            }
            if (currentSearchValue != oldSearchValue) {
                oldSearchValueList[searchBoxId] = currentSearchValue;
                if (searchBoxId.indexOf("persisted_") == 0) {
                    Cookies.set(searchBoxId, currentSearchValue);
                }
                var currentFilterRoot = grid.dataSource.filter();
                if (currentFilterRoot == null || currentFilterRoot.filters == null) {
                    var currentFilters = [];
                } else {
                    currentFilters = currentFilterRoot.filters;
                }
                KendoExtension.Grid.updateDataSourceFilter(currentFilters, "__Quick_Search", currentSearchValue);
                KendoExtension.Grid.updateDataSourceFilter(currentFilters, "__Quick_Search_Extra_Data", KendoExtension.Grid.extraFilterData);
                grid.dataSource.filter(currentFilters);
            } else {
                setTimeout(() => { KendoExtension.Grid.checkSearchChanged(grid, searchTextbox); }, filterDelay);
            }
        }

        private static updateDataSourceFilter(currentFilters: any[], filterName: string, filterValue: string) {
            var filterFound = false;
            for (var i = 0; i < currentFilters.length; i++) {
                if (currentFilters[i].field === filterName) {
                    if (filterValue === null || filterValue === "") {
                        currentFilters.splice(i, 1);
                    } else {
                        currentFilters[i].value = filterValue;
                    }
                    filterFound = true;
                    break;
                }
            }
            if (!filterFound && filterValue !== null && filterValue !== "") {
                currentFilters.push({ field: filterName, operator: "eq", value: filterValue });
            }
        }

        private static setupQuickSearchFilters($grids: any, persistFilter: boolean) {
            if ($grids !== undefined && $grids !== null && $grids.length > 0) {
                for (var i = 0; i < $grids.length; i++) {
                    if ($($grids[i]).find(".a-quick-search-container").length === 0) {
                        var grid = <kendo.ui.Grid>$($grids[i]).data("kendoGrid");
                        if (grid !== undefined) {
                            var interval = $($grids[i]).data("quicksearchinterval");
                            KendoExtension.Grid.initializeSearchBox(grid, persistFilter, null, interval);
                        }
                    }
                }
            }
        }

         static makeRowButtonsImageOnly($grid: any) {
            var buttons = $grid.find(".k-grid-delete, .k-grid-delete-command, .k-grid-remove-command");
            if (buttons !== undefined && buttons !== null && buttons.length > 0) {
                for (var i = 0; i < buttons.length; i++) {
                    var $button = $(buttons[i]);
                    var innerContent = $button.html().replace("Delete", "");
                    $button.attr("title", "Delete the record");
                    $button.html(innerContent);
                }
            }
            buttons = $grid.find(".k-grid-edit, .k-grid-edit-command");
            if (buttons !== undefined && buttons !== null && buttons.length > 0) {
                for (var i = 0; i < buttons.length; i++) {
                    var $button = $(buttons[i]);
                    innerContent = $button.html();
                    if (innerContent.indexOf("Edit") > 0) {
                        $button.attr("title", "Edit the record");
                        innerContent = innerContent.replace("Edit", "");
                    } else {
                        $button.attr("title", "View the record");
                        innerContent = innerContent.replace("View", "").replace("k-i-pencil", "k-i-search").replace("k-i-edit", "k-i-search");
                    }
                    $button.html(innerContent);
                }
            }
            KendoExtension.Grid.setupTooltips($grid);
        }

        static restoreGridPageSize(e) {
            var grid = e.sender;
            var id = grid.element.prop("id");
            var pageKey = "gridPageSize_" + id;
            var pageSize = localStorage[pageKey];
            if (!isNaN(pageSize) && grid.dataSource.pageSize() != pageSize) {
                e.preventDefault();
                kendo.ui.progress(grid.element, false);
                grid.dataSource.pageSize(pageSize);
            }
        }

        static saveGridPageSize(e) {
            var grid = e.sender.element.closest(".k-grid");
            var thisGrid = grid.data("kendoGrid");
            var gridId = grid.prop("id");
            var storageKey = "gridSettings_" + gridId;
            var pageKey = "gridPageSize_" + gridId;
            if (thisGrid) {
                localStorage[pageKey] = e.sender.value();
            }

        }

        static setupGridPageSizeRestore() {
            var grids = $(".k-grid");
            for (var i = 0; i < grids.length; i++) {
                var grid = $(grids[i]).data("kendoGrid");
                grid.bind("dataBinding", KendoExtension.Grid.restoreGridPageSize);
                var pageSizeDropDownList = grid.wrapper.children(".k-grid-pager").find("select").data("kendoDropDownList");
                if (pageSizeDropDownList)
                    pageSizeDropDownList.bind("change", KendoExtension.Grid.saveGridPageSize);

            }
        }
    }
}

var documentReady: boolean = false;
$(document).ready(() => {
    documentReady = true;
    $(window).resize(() => {
        var grid = <kendo.ui.Grid>$(".a-standardGrid").data("kendoGrid");
        if (grid !== undefined) {
            KendoExtension.Grid.adjustSize(grid);
        }
    });
});

$(window).on("load", () => {
    checkDocumentReady();
});

//To work around the jQuery 3.x breaking changes:
//  1.$(window).onload deprecated.
//  2.$(document).ready is now asynchronous. so $(window) load event may fire before it fires.
//The workaround is to wait for document ready then handle $(window) load event.deprecated
function checkDocumentReady() {
    setTimeout(() => {
        if (documentReady === false) {
            checkDocumentReady();
        } else {
            KendoExtension.Grid.setupQuickSearch();
            KendoExtension.Grid.setupTooltips($($("html")[0]));
            KendoExtension.Grid.setupGridPageSizeRestore();
        }
    }, 100);
}